// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store';
import * as utils from '@/common/utils';

// 解决点击当前面包屑报错问题
import Router from 'vue-router';
const routerPush = Router.prototype.push;
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error);
};

require('@/mock/index.js');

router.beforeEach((to, from, next) => {
  next();
});

Vue.use(ElementUI);

Vue.config.productionTip = false;

Vue.filter('timeFilter', utils.dateFormat);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js